import api from './axiosApi'
import type { PaginationMeta } from '@/types'

export interface LineItemCommentAuthor {
  id: string
  display_name?: string | null
}

export interface LineItemComment {
  id: string
  content: string
  author?: LineItemCommentAuthor | null
  mentions: string[]
  mentioned_users: LineItemCommentAuthor[]
  created_at: string
  updated_at?: string | null
  is_deleted?: boolean
}

export interface LineItemCommentListResponse {
  data: LineItemComment[]
  pagination: PaginationMeta
}

export async function listLineItemComments(
  refId: string,
  offset = 0,
  limit = 50
): Promise<LineItemCommentListResponse> {
  const response = await api.get<LineItemCommentListResponse>(
    `/line-items/${refId}/comments`,
    { params: { offset, limit } }
  )
  return response.data
}

export async function addLineItemComment(
  refId: string,
  content: string
): Promise<LineItemComment> {
  const response = await api.post<LineItemComment>(
    `/line-items/${refId}/comments`,
    { content }
  )
  return response.data
}

export async function deleteLineItemComment(commentId: string): Promise<void> {
  await api.delete(`/comments/${commentId}`)
}
